import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { upcomingMoons, fmtMoonDate, moonLabel } from "@/lib/content";
import { useBooking } from "./BookingContext";

const MoonRow = ({ m }) => {
  const { openBooking } = useBooking();
  return (
    <li data-testid={`moon-row-${m.date}`} className="group grid grid-cols-[1fr_auto] sm:grid-cols-[150px_1fr_200px_auto] items-center gap-x-6 gap-y-1 py-5 border-b border-[#E6E0D4]">
      <span className="text-xs uppercase tracking-[0.2em] text-[#A8613C]">{m.phase === "full" ? "Full moon" : "New moon"}</span>
      <span className="order-3 sm:order-none col-span-2 sm:col-span-1 font-display text-2xl sm:text-3xl text-[#2D2A26]">{m.name}{m.tag ? <span className="ml-2 text-sm font-sans text-[#6E685F]">({m.tag})</span> : null}</span>
      <span className="order-4 sm:order-none col-span-2 sm:col-span-1 text-sm text-[#5E584F]">{fmtMoonDate(m.date)}{m.time ? ` · ${m.time}` : ""}</span>
      <button type="button" data-testid={`moon-book-${m.date}`} onClick={() => openBooking("moon-ritual", moonLabel(m))} className="order-2 sm:order-none flex items-center gap-1 text-sm text-[#2D2A26] link-underline justify-self-end">
        Book <ArrowUpRight size={14} />
      </button>
    </li>
  );
};

export const MoonCalendar = () => {
  const moons = upcomingMoons();
  return (
    <section id="moon-calendar" data-testid="moon-calendar" className="py-24 sm:py-32 border-t border-[#E6E0D4]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-8">
        <div className="lg:col-span-4">
          <Reveal><Overline>Moon calendar</Overline></Reveal>
          <Reveal delay={0.1}><h2 className="mt-5 font-display font-light text-4xl sm:text-5xl text-[#2D2A26]">Upcoming moons.</h2></Reveal>
          <Reveal delay={0.15}><p className="mt-4 text-base text-[#5E584F] max-w-sm">Choose a moon and submit your desires. Each ritual is performed within the cycle you select.</p></Reveal>
        </div>
        <Reveal className="lg:col-span-8">
          {moons.length ? (
            <ul className="border-t border-[#E6E0D4]">{moons.map((m) => <MoonRow key={m.date + m.phase} m={m} />)}</ul>
          ) : (
            <p data-testid="moon-calendar-empty" className="font-display text-3xl text-[#2D2A26]">New moon dates for the coming year will be shared soon.</p>
          )}
        </Reveal>
      </div>
    </section>
  );
};
